// Scroll to the success message
$(document).ready(function () {
    var scrollToElement = $('[data-scroll="form-success"]');
    if(scrollToElement.length == 1) {
        setTimeout(function () {
            // scroll down until the scrollTo element is in the middle of the window
            var scrollTo = scrollToElement.offset().top - (window.innerHeight / 2);
            $("html, body").animate({scrollTop: scrollTo}, 600, function() {
                scrollToElement.animate({opacity: '0.2'}, 300);
                scrollToElement.animate({opacity: '1'}, 300);
            });
        }, 250);
    }
});